import { alertApiRef, useApi } from '@backstage/core-plugin-api';
import {
  CustomFieldExtensionSchema,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import { CatalogApi, catalogApiRef } from '@backstage/plugin-catalog-react';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { FieldValidation } from '@rjsf/utils';

import { FormHelperText, Typography } from '@material-ui/core';
import { getCookie, setCookie } from 'react-use-cookie';

let catalogApi: CatalogApi;

export const AppInventoryIdExtensionSchema: CustomFieldExtensionSchema = {
  uiOptions: {
    type: 'object',
    required: ['fieldName'],
    properties: {
      fieldName: {
        description:
          'The name of the field use to validate in the accounts API',
        type: 'string',
      },
      regexPattern: {
        description: 'An optional regex to apply to the input',
        type: 'string',
      },
      regexError: {
        description:
          'An optional error message for when the regex pattern does not match',
        type: 'string',
      },
      allowedEmpty: {
        description:
          "A flag indicating if a blank value is allowed. Used to bypass backstage's redundant validation on blank fields. Defaults to false.",
        type: 'boolean',
        default: false,
      },
      formattedHelp: {
        description:
          'Help text containing HTML elements for advanced formatting',
        type: 'string',
      },
    },
  },
  returnValue: { type: 'string' },
};

export const AppInventoryId = ({
  onChange,
  rawErrors,
  required,
  formData,
  uiSchema,
}: FieldExtensionComponentProps<string>) => {
  // Set up variables for accounts-api validation call
  const alertApi = useApi(alertApiRef);
  catalogApi = useApi(catalogApiRef);

  // if (customFormData.workloadEnvironments) {
  //   environmentInfo = JSON.parse(customFormData.workloadEnvironments);
  // }

  if (getCookie('appid_success_message') !== '') {
    alertApi.post({
      message: getCookie('appid_success_message'),
      severity: 'info',
    });
  }

  setCookie('appid_success_message', '', { path: '/' });

  const fieldName = uiSchema?.['ui:options']?.fieldName as string;
  return (
    <FormControl
      margin="normal"
      required={required}
      error={rawErrors !== undefined && rawErrors.length > 0 && !formData}
    >
      <InputLabel htmlFor="appInventoryIdInput">App Inventory Id</InputLabel>
      <Input
        id="appInventoryIdInput"
        defaultValue={formData}
        onChange={e => onChange(e.target?.value)}
      />
      {uiSchema?.['ui:options'] !== undefined && (
        <FormHelperText id={`${fieldName}HelperText`}>
          <Typography variant="body1">
            <div
              dangerouslySetInnerHTML={{
                __html: uiSchema['ui:options'].formattedHelp as string,
              }}
            />
          </Typography>
        </FormHelperText>
      )}
    </FormControl>
  );
};
/*
 This is a validation function that will run when the form is submitted.
  You will get the value from the `onChange` handler before as the value here to make sure that the types are aligned\
*/
export const validateAppInventoryId = async (
  value: any,
  validation: FieldValidation,
) => {
  const APP_INVENTORY_REGEX = '^appid-[0-9]+$|^no-entry$';
  const appInventoryRegex = new RegExp(APP_INVENTORY_REGEX);

  if (!appInventoryRegex.test(value)) {
    validation.addError('App Inventory Id must be either appid-* or no-entry');
  }

  try {
    if (value !== 'no-entry') {
      const { items } = await catalogApi.getEntities({
        filter: {
          kind: 'System',
          'spec.type': 'application',
          'metadata.name': value,
        },
        fields: ['metadata.name'],
      });
      if (items.length === 0) {
        validation.addError(
          `App Inventory Id must match the name of an existing entity in the PDP catalog. No matching entity found for ${value}. Please verify the ID is correct, change to 'no-entry', or contact the CPE for assistance.`,
        );
      }
    }
  } catch {
    validation.addError(
      `Unable to validate App Inventory ID against catalog. Please verify the ID is correct or contact the CPE for assistance.`,
    );
  }
};
